import APIService from '../api.service';

export interface CalendlyVerificationRequest {
  code: string;
  userId: string;
}

export interface CalendlyVerificationResponse {
  is_valid: boolean;
  is_used: boolean;
  free_session: {
    free_session_id: string;
    user_id: string;
    coach_id: string;
    coach_name: string;
    coach_lastname: string;
    free_session_scheduling_link: string;
  };
}

class CalendlyService {
  public async verifyCode(
    data: CalendlyVerificationRequest,
  ): Promise<CalendlyVerificationResponse> {
    const response = await APIService.post<{
      data: CalendlyVerificationResponse;
    }>('/coaches/free-session/check', {
      ...data,
      user_id: data.userId,
    });
    return response.data;
  }
}

export default new CalendlyService();
